import { MembershipTypeDiscountsDTO } from "../dto/MembershipTypeDiscountsDTO";
import { MembershipTypeDiscount } from "../models/MembershipTypeDiscount";

export const membershipTypeDiscountMapper = (
  dto: MembershipTypeDiscountsDTO,
): MembershipTypeDiscount => {
  return new MembershipTypeDiscount({
    id: dto.discountId,
    name: dto.description,
    amount: dto.discountAmt,
    membershipTypeId: dto.membershipTypeId,
  });
};
